<template>
  <div class="">
    <a-form-item v-for="(item, index) in questionList" :key="index" label="">
      <div class="df vertical">
        <div>{{ index + 1 }}</div>
        <a-textarea
          v-model:value="item.value"
          :placeholder="currentText"
          :style="
            props.textAreaStyle
              ? props.textAreaStyle
              : 'width: 700px; margin-right: 8px; height: auto'
          "
          :disabled="item.disabled"
          autoSize
        />
        <MinusCircleOutlined
          v-if="questionList.length > 0 && !item.disabled"
          class="dynamic-delete-button"
          :disabled="questionList.length === 1"
          @click="removeQuestion(item)"
        />
      </div>
    </a-form-item>
    <a-form-item v-bind="formItemLayoutWithOutLabel" v-if="!props.disabled">
      <a-button type="dashed" style="width: 60%" @click="addQuestion">
        <PlusOutlined />
        增加
      </a-button>
    </a-form-item>
  </div>
</template>

<script>
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { computed, defineComponent, reactive, ref, watch } from "vue";
export default defineComponent({
  props: {
    questionLists: String,
    noticeText: String,
    textAreaStyle: String,
    disabled: Boolean,
  },
  components: {
    MinusCircleOutlined,
    PlusOutlined,
  },
  setup(props) {
    const currentText = computed(() =>
      props.noticeText == null ? "售后问题" : props.noticeText
    );

    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 4,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 20,
        },
      },
    };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 20,
          offset: 4,
        },
      },
    };
    const questionList = reactive([]);
    const removeQuestion = (item) => {
      let index = questionList.indexOf(item);
      if (index !== -1) {
        questionList.splice(index, 1);
      }
    };
    const addQuestion = () => {
      questionList.push({
        value: "",
        disabled: false,
        key: Date.now(),
      });
    };
    // 校验售后问题
    const checkQuestionList = () => {
      const emptyList = questionList.filter((item) => item.value === "");
      if (emptyList.length > 0) {
        return Promise.reject(`请填写${currentText.value}`);
      } else {
        return Promise.resolve();
      }
    };

    const resetList = () => {
      questionList.length = 0;
    };

    // 回显数据
    watch(
      () => props.questionLists,
      (val) => {
        if (val) {
          questionList.length = 0;
          const list = JSON.parse(val);
          questionList.push(...list);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      props,
      formItemLayout,
      formItemLayoutWithOutLabel,
      questionList,
      removeQuestion,
      addQuestion,
      checkQuestionList,
      resetList,
      currentText,
    };
  },
});
</script>
<style>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
